var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _clipPath56, _clipPath57, _clipPath58, _clipPath59, _clipPath60, _clipPath61, _clipPath62, _clipPath63, _clipPath64, _clipPath65, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "2000pt",
    height: "2000pt",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(254.089844,0,0,153.332031,534.164063,1151.28125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(34.117647%,38.039216%,84.313725%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(30.196078%,60.784314%,85.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(26.666667%,83.137255%,87.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(25.882353%,89.019608%,87.45098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(25.882353%,90.980392%,87.843137%)",
      stopOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 537.175781 1304.613281 C 535.769531 1304.648438 534.523438 1303.6875 534.164062 1302.289062 C 533.800781 1300.890625 534.417969 1299.417969 535.65625 1298.730469 L 783.566406 1151.386719 C 784.507812 1150.761719 785.707031 1150.722656 786.6875 1151.28125 C 787.667969 1151.84375 788.269531 1152.914062 788.253906 1154.066406 C 788.234375 1155.222656 787.601562 1156.269531 786.605469 1156.800781 L 538.695312 1304.1875 C 538.238281 1304.46875 537.710938 1304.613281 537.175781 1304.613281 Z M 537.175781 1304.613281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(252.699219,0,0,152.496094,1210.328125,1151.328125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(25.882353%,90.980392%,87.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    style: {
      stopColor: "rgb(25.882353%,89.019608%,87.45098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "rgb(26.666667%,83.137255%,87.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    style: {
      stopColor: "rgb(30.196078%,60.784314%,85.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(34.117647%,38.039216%,84.313725%)",
      stopOpacity: 1
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 1460.011719 1303.789062 C 1459.480469 1303.789062 1458.960938 1303.640625 1458.503906 1303.363281 L 1211.976562 1156.847656 C 1210.980469 1156.320312 1210.347656 1155.269531 1210.328125 1154.113281 C 1210.3125 1152.960938 1210.914062 1151.890625 1211.894531 1151.328125 C 1212.875 1150.769531 1214.074219 1150.808594 1215.015625 1151.433594 L 1461.53125 1297.941406 C 1462.769531 1298.628906 1463.386719 1300.101562 1463.027344 1301.5 C 1462.664062 1302.898438 1461.417969 1303.859375 1460.011719 1303.824219 Z M 1460.011719 1303.789062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(951.398438,0,0,278.96875,521.40625,1516.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(34.117647%,38.039216%,84.313725%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(30.196078%,60.784314%,85.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(26.666667%,83.137255%,87.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(25.882353%,89.019608%,87.45098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(25.882353%,90.980392%,87.843137%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 997.863281 1795.90625 C 987.71875 1795.910156 977.753906 1793.164062 968.972656 1787.941406 C 867.921875 1727.648438 531.417969 1527.375 523.347656 1523.683594 C 522.589844 1523.449219 521.953125 1522.910156 521.589844 1522.1875 C 521.222656 1521.464844 521.15625 1520.621094 521.40625 1519.847656 C 521.941406 1518.179688 523.671875 1517.253906 525.304688 1517.765625 C 530.546875 1519.316406 967.589844 1779.894531 972.023438 1782.46875 C 988.035156 1791.972656 1007.757812 1791.972656 1023.769531 1782.46875 L 1468.34375 1517.257812 C 1469.796875 1516.390625 1471.660156 1516.902344 1472.503906 1518.398438 C 1473.34375 1519.898438 1472.847656 1521.816406 1471.394531 1522.683594 L 1026.789062 1787.929688 C 1017.992188 1793.15625 1008.019531 1795.90625 997.863281 1795.90625 Z M 997.863281 1795.90625 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: -0.247,
    y1: 0.5,
    x2: 1.034,
    y2: 0.5,
    gradientTransform: "matrix(833.542969,0,0,297.28125,581.074219,856.847656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(1.568627%,10.196078%,12.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "rgb(34.509804%,34.117647%,34.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    style: {
      stopColor: "rgb(34.509804%,34.117647%,34.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    style: {
      stopColor: "rgb(1.568627%,10.196078%,12.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(1.568627%,10.196078%,12.941176%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.863281 1047.433594 L 677.304688 856.917969 L 997.863281 666.398438 L 1318.421875 856.917969 Z M 997.863281 1047.433594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.839844 618.351562 L 1318.398438 808.871094 L 1318.398438 856.90625 L 997.839844 666.433594 Z M 997.839844 618.351562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.863281 666.433594 L 677.292969 856.90625 L 677.292969 808.871094 L 997.851562 618.351562 Z M 997.863281 666.433594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.863281 999.375 L 677.304688 808.859375 L 997.863281 618.339844 L 1318.421875 808.859375 Z M 997.863281 999.375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.851562 885 L 869.761719 808.871094 L 997.851562 732.742188 L 1125.941406 808.871094 Z M 997.851562 885 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.851562 739.753906 L 1120.046875 812.375 L 1125.941406 808.847656 L 997.851562 732.71875 L 869.761719 808.847656 L 875.65625 812.375 Z M 997.851562 739.753906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.851562 999.386719 L 997.851562 1047.421875 L 1318.410156 856.90625 L 1318.410156 808.871094 Z M 997.851562 999.386719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 677.292969 808.871094 L 677.292969 856.90625 L 997.851562 1047.421875 L 997.851562 999.386719 Z M 677.292969 808.871094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.8,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.851562 994.140625 L 681.703125 806.234375 L 677.292969 808.859375 L 997.863281 999.375 L 1318.410156 808.871094 L 1314 806.246094 Z M 997.851562 994.140625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 381.3125 1208.871094 C 364.527344 1198.910156 343.859375 1198.910156 327.074219 1208.871094 L 3.769531 1400.480469 C 1.410156 1401.886719 -0.046875 1404.480469 -0.046875 1407.289062 C -0.046875 1410.097656 1.410156 1412.691406 3.769531 1414.09375 L 329.714844 1607.8125 C 344.523438 1616.613281 362.769531 1616.613281 377.578125 1607.8125 L 704.023438 1414.269531 C 706.386719 1412.867188 707.839844 1410.273438 707.839844 1407.464844 C 707.839844 1404.65625 706.386719 1402.0625 704.023438 1400.660156 Z M 381.3125 1208.871094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 381.3125 1152.789062 C 364.527344 1142.828125 343.859375 1142.828125 327.074219 1152.789062 L 3.769531 1344.433594 C 1.410156 1345.839844 -0.046875 1348.433594 -0.046875 1351.242188 C -0.046875 1354.046875 1.410156 1356.644531 3.769531 1358.046875 L 329.714844 1551.765625 C 344.523438 1560.566406 362.769531 1560.566406 377.578125 1551.765625 L 704.023438 1358.222656 C 706.378906 1356.816406 707.828125 1354.226562 707.828125 1351.421875 C 707.828125 1348.621094 706.378906 1346.027344 704.023438 1344.625 Z M 381.3125 1152.789062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 381.3125 1096.71875 C 364.527344 1086.753906 343.859375 1086.753906 327.074219 1096.71875 L 3.769531 1288.375 C 1.410156 1289.78125 -0.046875 1292.375 -0.046875 1295.183594 C -0.046875 1297.988281 1.410156 1300.585938 3.769531 1301.988281 L 329.714844 1495.707031 C 344.523438 1504.507812 362.769531 1504.507812 377.578125 1495.707031 L 704.023438 1302.164062 C 706.386719 1300.761719 707.839844 1298.167969 707.839844 1295.359375 C 707.839844 1292.550781 706.386719 1289.957031 704.023438 1288.554688 Z M 381.3125 1096.71875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 381.3125 1040.683594 C 364.53125 1030.714844 343.859375 1030.714844 327.074219 1040.683594 L 3.769531 1232.316406 C 1.410156 1233.722656 -0.046875 1236.316406 -0.046875 1239.125 C -0.046875 1241.929688 1.410156 1244.527344 3.769531 1245.929688 L 329.714844 1439.648438 C 344.523438 1448.449219 362.769531 1448.449219 377.578125 1439.648438 L 704.023438 1246.105469 C 706.386719 1244.703125 707.839844 1242.109375 707.839844 1239.300781 C 707.839844 1236.492188 706.386719 1233.898438 704.023438 1232.492188 Z M 381.3125 1040.683594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 704.078125 1232.445312 L 381.3125 1040.683594 C 364.53125 1030.714844 343.859375 1030.714844 327.074219 1040.683594 L 3.769531 1232.316406 C 1.398438 1233.710938 -0.0625 1236.316406 -0.046875 1239.128906 L -0.046875 1351.835938 C -0.0585938 1354.644531 1.398438 1357.246094 3.769531 1358.636719 L 329.714844 1552.363281 C 344.523438 1561.160156 362.765625 1561.160156 377.578125 1552.363281 L 704.023438 1358.824219 C 706.394531 1357.425781 707.855469 1354.824219 707.839844 1352.011719 L 707.839844 1239.304688 C 707.886719 1236.488281 706.449219 1233.863281 704.078125 1232.445312 Z M 704.078125 1232.445312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 381.3125 1040.683594 C 364.53125 1030.714844 343.859375 1030.714844 327.074219 1040.683594 L 3.769531 1232.316406 C 1.410156 1233.722656 -0.046875 1236.316406 -0.046875 1239.125 C -0.046875 1241.929688 1.410156 1244.527344 3.769531 1245.929688 L 329.714844 1439.648438 C 344.523438 1448.449219 362.769531 1448.449219 377.578125 1439.648438 L 704.023438 1246.105469 C 706.386719 1244.703125 707.839844 1242.109375 707.839844 1239.300781 C 707.839844 1236.492188 706.386719 1233.898438 704.023438 1232.492188 Z M 381.3125 1040.683594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 365.542969 1150.542969 C 358.433594 1146.316406 349.671875 1146.316406 342.558594 1150.542969 L 197.726562 1236.421875 C 196.683594 1237.058594 196.046875 1238.214844 196.046875 1239.457031 C 196.046875 1240.703125 196.683594 1241.859375 197.726562 1242.492188 L 343.152344 1328.929688 C 349.761719 1332.851562 357.898438 1332.851562 364.503906 1328.929688 L 510.160156 1242.578125 C 511.199219 1241.941406 511.839844 1240.785156 511.839844 1239.542969 C 511.839844 1238.296875 511.199219 1237.140625 510.160156 1236.507812 Z M 365.542969 1150.542969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1669.121094 1208.871094 C 1652.335938 1198.910156 1631.664062 1198.910156 1614.878906 1208.871094 L 1291.621094 1400.554688 C 1289.261719 1401.957031 1287.804688 1404.550781 1287.804688 1407.359375 C 1287.804688 1410.167969 1289.261719 1412.761719 1291.621094 1414.164062 L 1617.566406 1607.882812 C 1632.375 1616.6875 1650.621094 1616.6875 1665.429688 1607.882812 L 1991.886719 1414.339844 C 1994.246094 1412.9375 1995.703125 1410.34375 1995.703125 1407.535156 C 1995.703125 1404.726562 1994.246094 1402.132812 1991.886719 1400.730469 Z M 1669.121094 1208.871094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1669.121094 1152.789062 C 1652.335938 1142.828125 1631.664062 1142.828125 1614.878906 1152.789062 L 1291.621094 1344.46875 C 1289.261719 1345.875 1287.804688 1348.46875 1287.804688 1351.277344 C 1287.804688 1354.085938 1289.261719 1356.679688 1291.621094 1358.082031 L 1617.566406 1551.800781 C 1632.375 1560.605469 1650.621094 1560.605469 1665.429688 1551.800781 L 1991.886719 1358.257812 C 1994.242188 1356.851562 1995.691406 1354.261719 1995.691406 1351.457031 C 1995.691406 1348.65625 1994.242188 1346.0625 1991.886719 1344.660156 Z M 1669.121094 1152.789062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1669.121094 1096.71875 C 1652.335938 1086.753906 1631.664062 1086.753906 1614.878906 1096.71875 L 1291.621094 1288.398438 C 1289.261719 1289.804688 1287.804688 1292.398438 1287.804688 1295.207031 C 1287.804688 1298.011719 1289.261719 1300.609375 1291.621094 1302.011719 L 1617.566406 1495.730469 C 1632.375 1504.53125 1650.621094 1504.53125 1665.429688 1495.730469 L 1991.886719 1302.1875 C 1994.246094 1300.785156 1995.703125 1298.191406 1995.703125 1295.382812 C 1995.703125 1292.574219 1994.246094 1289.980469 1991.886719 1288.578125 Z M 1669.121094 1096.71875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1669.121094 1040.683594 C 1652.335938 1030.71875 1631.664062 1030.71875 1614.878906 1040.683594 L 1291.621094 1232.363281 C 1289.261719 1233.769531 1287.804688 1236.363281 1287.804688 1239.171875 C 1287.804688 1241.976562 1289.261719 1244.574219 1291.621094 1245.976562 L 1617.566406 1439.695312 C 1632.375 1448.496094 1650.621094 1448.496094 1665.429688 1439.695312 L 1991.886719 1246.152344 C 1994.246094 1244.75 1995.703125 1242.15625 1995.703125 1239.347656 C 1995.703125 1236.539062 1994.246094 1233.945312 1991.886719 1232.542969 Z M 1669.121094 1040.683594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface74",
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1991.886719 1232.445312 L 1669.121094 1040.683594 C 1652.335938 1030.71875 1631.664062 1030.71875 1614.878906 1040.683594 L 1291.621094 1232.363281 C 1289.25 1233.757812 1287.789062 1236.363281 1287.804688 1239.175781 L 1287.804688 1351.882812 C 1287.792969 1354.691406 1289.25 1357.292969 1291.621094 1358.683594 L 1617.566406 1552.410156 C 1632.375 1561.210938 1650.617188 1561.210938 1665.429688 1552.410156 L 1991.886719 1358.871094 C 1994.257812 1357.476562 1995.71875 1354.871094 1995.703125 1352.058594 L 1995.703125 1239.351562 C 1995.753906 1236.503906 1994.289062 1233.855469 1991.886719 1232.445312 Z M 1991.886719 1232.445312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface77",
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1669.121094 1040.683594 C 1652.335938 1030.71875 1631.664062 1030.71875 1614.878906 1040.683594 L 1291.621094 1232.363281 C 1289.261719 1233.769531 1287.804688 1236.363281 1287.804688 1239.171875 C 1287.804688 1241.976562 1289.261719 1244.574219 1291.621094 1245.976562 L 1617.566406 1439.695312 C 1632.375 1448.496094 1650.621094 1448.496094 1665.429688 1439.695312 L 1991.886719 1246.152344 C 1994.246094 1244.75 1995.703125 1242.15625 1995.703125 1239.347656 C 1995.703125 1236.539062 1994.246094 1233.945312 1991.886719 1232.542969 Z M 1669.121094 1040.683594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface80",
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1653.347656 1150.542969 C 1646.238281 1146.316406 1637.476562 1146.316406 1630.367188 1150.542969 L 1485.53125 1236.421875 C 1484.492188 1237.058594 1483.851562 1238.214844 1483.851562 1239.457031 C 1483.851562 1240.703125 1484.492188 1241.859375 1485.53125 1242.492188 L 1630.9375 1328.976562 C 1637.546875 1332.902344 1645.6875 1332.902344 1652.296875 1328.976562 L 1797.953125 1242.625 C 1798.996094 1241.988281 1799.632812 1240.835938 1799.632812 1239.589844 C 1799.632812 1238.34375 1798.996094 1237.1875 1797.953125 1236.554688 Z M 1653.347656 1150.542969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface83",
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1908.046875 769.492188 L 1908.046875 570.1875 C 1902.21875 500.0625 1876.316406 433.292969 1833.613281 378.328125 L 1833.613281 577.589844 C 1876.316406 632.550781 1902.21875 699.320312 1908.046875 769.445312 Z M 1811.210938 549.636719 L 1811.210938 350.328125 C 1795.234375 331.875 1778.109375 314.507812 1759.941406 298.339844 L 1759.941406 497.589844 C 1778.109375 513.753906 1795.234375 531.121094 1811.210938 549.578125 Z M 1728.230469 471.082031 L 1728.230469 271.765625 C 1707.246094 255.34375 1685.4375 240.070312 1662.890625 226.011719 L 1662.890625 425.316406 C 1685.4375 439.378906 1707.246094 454.648438 1728.230469 471.070312 Z M 1619.027344 458.554688 L 1619.027344 141.445312 C 1797.40625 238.859375 1908.742188 378.175781 1908.742188 532.304688 L 1908.742188 849.351562 C 1908.742188 695.234375 1797.40625 555.90625 1619.027344 458.492188 Z M 1619.027344 458.554688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface86",
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1292.835938 306.316406 L 1292.835938 249.058594 C 1279.21875 246.375 1265.464844 243.882812 1251.578125 241.578125 L 1251.578125 298.835938 C 1265.472656 301.140625 1279.226562 303.636719 1292.835938 306.316406 Z M 1218.617188 236.492188 L 1218.617188 185.824219 C 1204.507812 183.816406 1190.273438 182.011719 1175.921875 180.410156 L 1175.921875 231.082031 C 1190.28125 232.691406 1204.515625 234.492188 1218.617188 236.492188 Z M 1364.261719 265.164062 L 1364.261719 196.082031 C 1351.203125 192.75 1337.984375 189.613281 1324.605469 186.671875 L 1324.605469 255.765625 C 1337.984375 258.738281 1351.203125 261.875 1364.261719 265.175781 Z M 1141.839844 227.660156 L 1141.839844 125.660156 C 1127.304688 124.371094 1112.660156 123.289062 1097.910156 122.410156 L 1097.910156 224.410156 C 1112.667969 225.289062 1127.308594 226.371094 1141.839844 227.660156 Z M 982.433594 221.917969 L 982.433594 119.917969 C 967.492188 120.152344 952.636719 120.601562 937.863281 121.257812 L 937.863281 223.269531 C 952.613281 222.613281 967.46875 222.164062 982.433594 221.929688 Z M 903.246094 225.199219 L 903.246094 96.964844 C 888.648438 97.953125 874.171875 99.128906 859.816406 100.492188 L 859.816406 228.730469 C 874.203125 227.332031 888.679688 226.15625 903.246094 225.199219 Z M 1062.890625 222.753906 L 1062.890625 76.011719 C 1049.550781 75.527344 1036.132812 75.210938 1022.640625 75.070312 L 1017.851562 75.070312 L 1017.851562 221.777344 L 1022.640625 221.777344 C 1036.132812 221.917969 1049.550781 222.226562 1062.890625 222.707031 Z M 826.035156 232.433594 L 826.035156 48.90625 C 811.824219 50.617188 797.730469 52.523438 783.75 54.625 L 783.75 238.152344 C 797.714844 236.050781 811.808594 234.144531 826.035156 232.433594 Z M 692.9375 33.164062 C 801.328125 9.761719 911.886719 -1.332031 1022.628906 0.0820312 C 1167.105469 0.683594 1310.675781 23.617188 1448.539062 68.117188 L 1448.539062 385.222656 C 1310.671875 340.726562 1167.097656 317.796875 1022.617188 317.199219 C 911.875 315.785156 801.316406 326.875 692.925781 350.269531 L 692.925781 33.164062 Z M 692.9375 33.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface89",
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 168.847656 463.269531 L 168.847656 399.433594 C 150.855469 425.792969 136.148438 454.371094 125.0625 484.492188 L 125.0625 673.589844 C 136.148438 643.460938 150.855469 614.878906 168.847656 588.519531 L 168.847656 524.683594 C 174.179688 516.777344 179.828125 508.960938 185.792969 501.234375 L 185.792969 535.671875 C 197.363281 520.714844 209.734375 506.433594 222.847656 492.894531 L 222.847656 458.457031 C 288.808594 392.921875 365.757812 340.230469 449.964844 302.929688 L 449.964844 241.519531 C 433.660156 249.085938 417.816406 256.972656 402.433594 265.175781 C 394.738281 269.285156 387.164062 273.464844 379.714844 277.71875 C 324.460938 308.578125 273.464844 346.90625 228.078125 391.683594 C 226.3125 393.460938 224.5625 395.25 222.835938 397.046875 L 222.835938 362.625 C 209.722656 376.164062 197.351562 390.445312 185.78125 405.398438 L 185.78125 439.835938 C 179.824219 447.554688 174.175781 455.367188 168.835938 463.28125 Z M 113.074219 461.269531 C 148.101562 306.53125 295.371094 173.257812 504.261719 90.304688 L 504.261719 407.421875 C 295.371094 490.363281 148.113281 623.636719 113.074219 778.386719 Z M 113.074219 461.269531 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface92",
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 222.847656 397.058594 C 224.574219 395.261719 226.320312 393.472656 228.078125 391.695312 L 228.078125 453.105469 C 261.199219 420.132812 297.554688 390.792969 336.558594 365.554688 C 350.433594 356.460938 364.820312 347.660156 379.714844 339.140625 L 379.714844 277.753906 C 387.164062 273.503906 394.738281 269.320312 402.433594 265.210938 L 402.433594 326.625 C 417.800781 318.417969 433.644531 310.535156 449.964844 302.964844 C 365.757812 340.265625 288.808594 392.957031 222.847656 458.492188 Z M 168.847656 463.28125 C 174.179688 455.375 179.828125 447.5625 185.792969 439.835938 L 185.792969 501.246094 C 179.835938 508.964844 174.1875 516.78125 168.847656 524.695312 Z M 168.847656 463.28125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.878431,
      stroke: "none"
    }
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface95",
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 402.421875 265.1875 C 417.789062 256.984375 433.632812 249.097656 449.953125 241.53125 L 449.953125 302.941406 C 433.648438 310.511719 417.804688 318.394531 402.421875 326.601562 Z M 402.421875 265.1875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.878431,
      stroke: "none"
    }
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface98",
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 228.078125 391.695312 C 261.199219 358.722656 297.554688 329.382812 336.558594 304.140625 L 336.558594 365.554688 C 297.554688 390.792969 261.199219 420.132812 228.078125 453.105469 Z M 228.078125 391.695312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface101",
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 336.558594 304.117188 C 350.433594 295.027344 364.820312 286.222656 379.714844 277.707031 L 379.714844 339.117188 C 364.828125 347.628906 350.441406 356.429688 336.558594 365.53125 Z M 336.558594 304.117188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface104",
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 125.0625 484.492188 C 136.148438 454.371094 150.855469 425.792969 168.847656 399.433594 L 168.847656 463.28125 C 150.859375 489.640625 136.148438 518.21875 125.0625 548.339844 L 125.0625 609.753906 C 136.148438 579.628906 150.859375 551.054688 168.847656 524.695312 L 168.847656 588.542969 C 150.855469 614.902344 136.148438 643.484375 125.0625 673.613281 Z M 125.0625 484.492188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.878431,
      stroke: "none"
    }
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface107",
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 125.0625 548.351562 C 136.148438 518.230469 150.859375 489.652344 168.847656 463.292969 L 168.847656 524.707031 C 150.859375 551.066406 136.148438 579.640625 125.0625 609.765625 Z M 125.0625 548.351562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface110",
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 185.78125 501.234375 C 197.351562 486.28125 209.722656 472 222.835938 458.457031 L 222.835938 492.894531 C 209.722656 506.433594 197.351562 520.714844 185.78125 535.671875 Z M 185.78125 405.398438 C 197.351562 390.445312 209.722656 376.164062 222.835938 362.625 L 222.835938 397.058594 C 209.722656 410.597656 197.351562 424.878906 185.78125 439.835938 Z M 185.78125 405.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.878431,
      stroke: "none"
    }
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface113",
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 185.78125 439.835938 C 197.351562 424.878906 209.722656 410.597656 222.835938 397.058594 L 222.835938 458.46875 C 209.722656 472.011719 197.351562 486.292969 185.78125 501.246094 Z M 185.78125 439.835938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface116",
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1833.613281 378.316406 C 1876.316406 433.28125 1902.21875 500.050781 1908.046875 570.175781 L 1908.046875 769.492188 C 1902.21875 699.367188 1876.316406 632.597656 1833.613281 577.636719 Z M 1833.613281 378.316406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface119",
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1662.925781 226.011719 C 1685.46875 240.070312 1707.28125 255.34375 1728.261719 271.765625 L 1728.261719 471.070312 C 1707.28125 454.636719 1685.472656 439.351562 1662.925781 425.28125 Z M 1662.925781 226.011719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface122",
    clipPath: "url(#clip40)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1324.605469 186.625 C 1337.984375 189.597656 1351.203125 192.734375 1364.261719 196.035156 L 1364.261719 265.128906 C 1351.203125 261.796875 1337.984375 258.660156 1324.605469 255.71875 Z M 1324.605469 186.625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface125",
    clipPath: "url(#clip41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1251.578125 241.566406 C 1265.472656 243.871094 1279.226562 246.363281 1292.835938 249.046875 L 1292.835938 306.304688 C 1279.226562 303.625 1265.472656 301.128906 1251.578125 298.824219 Z M 1251.578125 241.566406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface128",
    clipPath: "url(#clip42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1175.910156 180.398438 C 1190.269531 181.96875 1204.503906 183.773438 1218.605469 185.8125 L 1218.605469 236.480469 C 1204.496094 234.480469 1190.261719 232.679688 1175.910156 231.070312 Z M 1175.910156 180.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface131",
    clipPath: "url(#clip43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1097.929688 122.410156 C 1112.691406 123.28125 1127.332031 124.363281 1141.863281 125.660156 L 1141.863281 227.660156 C 1127.324219 226.371094 1112.683594 225.289062 1097.929688 224.410156 Z M 1097.929688 122.410156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface134",
    clipPath: "url(#clip44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1017.851562 75.023438 L 1022.640625 75.023438 C 1036.132812 75.164062 1049.550781 75.476562 1062.890625 75.964844 L 1062.890625 222.742188 C 1049.550781 222.253906 1036.132812 221.945312 1022.640625 221.8125 L 1017.851562 221.8125 Z M 1017.851562 75.023438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface137",
    clipPath: "url(#clip45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 859.761719 100.492188 C 874.144531 99.097656 888.621094 97.921875 903.1875 96.964844 L 903.1875 225.199219 C 888.589844 226.179688 874.113281 227.355469 859.761719 228.730469 Z M 859.761719 100.492188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(665.550781,0,0,388.378906,663.664063,1613.863281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface140",
    clipPath: "url(#clip46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 970.707031 1620.894531 C 986.488281 1611.523438 1005.921875 1611.523438 1021.703125 1620.894531 L 1325.621094 1801.105469 C 1327.84375 1802.425781 1329.214844 1804.863281 1329.214844 1807.507812 C 1329.214844 1810.148438 1327.84375 1812.585938 1325.621094 1813.90625 L 1019.175781 1996.035156 C 1005.253906 2004.3125 988.097656 2004.3125 974.171875 1996.035156 L 667.257812 1814.070312 C 665.035156 1812.753906 663.664062 1810.316406 663.664062 1807.675781 C 663.664062 1805.035156 665.035156 1802.597656 667.257812 1801.28125 Z M 970.707031 1620.894531 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(665.550781,0,0,388.375,663.664063,1561.21875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface143",
    clipPath: "url(#clip47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 970.707031 1568.246094 C 986.488281 1558.878906 1005.921875 1558.878906 1021.703125 1568.246094 L 1325.621094 1748.457031 C 1327.84375 1749.777344 1329.214844 1752.21875 1329.214844 1754.859375 C 1329.214844 1757.5 1327.84375 1759.941406 1325.621094 1761.257812 L 1019.175781 1943.386719 C 1005.253906 1951.664062 988.097656 1951.664062 974.171875 1943.386719 L 667.257812 1761.433594 C 665.035156 1760.117188 663.664062 1757.675781 663.664062 1755.035156 C 663.664062 1752.394531 665.035156 1749.953125 667.257812 1748.636719 Z M 970.707031 1568.246094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(665.550781,0,0,388.363281,663.664063,1508.511719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface146",
    clipPath: "url(#clip48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 970.707031 1515.542969 C 986.488281 1506.171875 1005.921875 1506.171875 1021.703125 1515.542969 L 1325.621094 1695.742188 C 1327.84375 1697.058594 1329.214844 1699.5 1329.214844 1702.140625 C 1329.214844 1704.78125 1327.84375 1707.222656 1325.621094 1708.542969 L 1019.175781 1890.671875 C 1005.253906 1898.945312 988.097656 1898.945312 974.171875 1890.671875 L 667.257812 1708.71875 C 665.035156 1707.398438 663.664062 1704.957031 663.664062 1702.316406 C 663.664062 1699.675781 665.035156 1697.238281 667.257812 1695.917969 Z M 970.707031 1515.542969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(665.503906,0,0,388.292969,663.710937,1455.867188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface149",
    clipPath: "url(#clip49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 970.707031 1462.894531 C 986.488281 1453.527344 1005.921875 1453.527344 1021.703125 1462.894531 L 1325.621094 1643.105469 C 1327.84375 1644.425781 1329.214844 1646.863281 1329.214844 1649.507812 C 1329.214844 1652.148438 1327.84375 1654.585938 1325.621094 1655.90625 L 1019.222656 1837.953125 C 1005.296875 1846.230469 988.140625 1846.230469 974.21875 1837.953125 L 667.304688 1656 C 665.082031 1654.679688 663.710938 1652.242188 663.710938 1649.601562 C 663.710938 1646.960938 665.082031 1644.519531 667.304688 1643.199219 Z M 970.707031 1462.894531 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(665.542969,0,0,546.492187,663.667969,1455.867188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface152",
    clipPath: "url(#clip50)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 667.304688 1643.1875 L 970.707031 1462.894531 C 986.488281 1453.527344 1005.921875 1453.527344 1021.703125 1462.894531 L 1325.621094 1643.105469 C 1327.855469 1644.414062 1329.230469 1646.859375 1329.210938 1649.507812 L 1329.210938 1807.625 C 1329.226562 1810.269531 1327.855469 1812.714844 1325.621094 1814.023438 L 1019.175781 1996.152344 C 1005.253906 2004.429688 988.097656 2004.429688 974.171875 1996.152344 L 667.257812 1814.1875 C 665.023438 1812.878906 663.652344 1810.433594 663.667969 1807.789062 L 663.667969 1649.601562 C 663.660156 1646.941406 665.050781 1644.488281 667.304688 1643.1875 Z M 667.304688 1643.1875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(807,0,0,470.910156,592.980469,1325.082031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface155",
    clipPath: "url(#clip51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear9)"
    },
    d: "M 965.292969 1333.601562 C 984.425781 1322.242188 1007.988281 1322.242188 1027.121094 1333.601562 L 1395.632812 1552.105469 C 1398.324219 1553.707031 1399.980469 1556.664062 1399.980469 1559.863281 C 1399.980469 1563.0625 1398.324219 1566.019531 1395.632812 1567.625 L 1024.046875 1788.46875 C 1007.164062 1798.503906 986.367188 1798.503906 969.484375 1788.46875 L 597.324219 1567.835938 C 594.636719 1566.234375 592.980469 1563.277344 592.980469 1560.078125 C 592.980469 1556.878906 594.636719 1553.921875 597.324219 1552.316406 Z M 965.292969 1333.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(807,0,0,470.921875,592.980469,1261.175781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface158",
    clipPath: "url(#clip52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear10)"
    },
    d: "M 965.292969 1269.695312 C 984.425781 1258.339844 1007.988281 1258.339844 1027.121094 1269.695312 L 1395.632812 1488.210938 C 1398.324219 1489.8125 1399.980469 1492.769531 1399.980469 1495.96875 C 1399.980469 1499.167969 1398.324219 1502.125 1395.632812 1503.730469 L 1024.046875 1724.578125 C 1007.164062 1734.605469 986.367188 1734.605469 969.484375 1724.578125 L 597.324219 1503.941406 C 594.636719 1502.339844 592.980469 1499.382812 592.980469 1496.183594 C 592.980469 1492.984375 594.636719 1490.027344 597.324219 1488.421875 Z M 965.292969 1269.695312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(807.011719,0,0,470.878906,592.980469,1197.28125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface161",
    clipPath: "url(#clip53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear11)"
    },
    d: "M 965.292969 1205.800781 C 984.421875 1194.441406 1007.988281 1194.441406 1027.121094 1205.800781 L 1395.632812 1424.316406 C 1398.332031 1425.914062 1399.992188 1428.875 1399.992188 1432.078125 C 1399.992188 1435.277344 1398.332031 1438.238281 1395.632812 1439.835938 L 1024.058594 1660.636719 C 1007.175781 1670.667969 986.378906 1670.667969 969.496094 1660.636719 L 597.335938 1440 C 594.640625 1438.402344 592.980469 1435.445312 592.980469 1432.242188 C 592.980469 1429.039062 594.640625 1426.082031 597.335938 1424.480469 Z M 965.292969 1205.800781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(806.988281,0,0,470.925781,592.992187,1133.398438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface164",
    clipPath: "url(#clip54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear12)"
    },
    d: "M 965.292969 1141.917969 C 984.425781 1130.5625 1007.988281 1130.5625 1027.121094 1141.917969 L 1395.632812 1360.433594 C 1398.324219 1362.039062 1399.980469 1364.996094 1399.980469 1368.195312 C 1399.980469 1371.394531 1398.324219 1374.351562 1395.632812 1375.953125 L 1024.046875 1596.800781 C 1007.164062 1606.832031 986.367188 1606.832031 969.484375 1596.800781 L 597.335938 1376.035156 C 594.648438 1374.433594 592.992188 1371.476562 592.992188 1368.277344 C 592.992188 1365.078125 594.648438 1362.121094 597.335938 1360.519531 Z M 965.292969 1141.917969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(807.050781,0,0,662.691406,592.984375,1133.363281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface167",
    clipPath: "url(#clip55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear13)"
    },
    d: "M 597.335938 1360.578125 L 965.335938 1141.882812 C 984.472656 1130.527344 1008.03125 1130.527344 1027.164062 1141.882812 L 1395.679688 1360.398438 C 1398.386719 1361.988281 1400.050781 1364.957031 1400.035156 1368.164062 L 1400.035156 1559.929688 C 1400.050781 1563.132812 1398.386719 1566.097656 1395.679688 1567.683594 L 1024.089844 1788.53125 C 1007.210938 1798.5625 986.414062 1798.5625 969.53125 1788.53125 L 597.335938 1567.800781 C 594.632812 1566.214844 592.96875 1563.25 592.984375 1560.046875 L 592.984375 1368.28125 C 592.988281 1365.097656 594.648438 1362.15625 597.335938 1360.578125 Z M 597.335938 1360.578125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.109804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(806.988281,0,0,470.925781,592.992187,1133.398438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface170",
    clipPath: "url(#clip56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear14)"
    },
    d: "M 965.292969 1141.917969 C 984.425781 1130.5625 1007.988281 1130.5625 1027.121094 1141.917969 L 1395.632812 1360.433594 C 1398.324219 1362.039062 1399.980469 1364.996094 1399.980469 1368.195312 C 1399.980469 1371.394531 1398.324219 1374.351562 1395.632812 1375.953125 L 1024.046875 1596.800781 C 1007.164062 1606.832031 986.367188 1606.832031 969.484375 1596.800781 L 597.335938 1376.035156 C 594.648438 1374.433594 592.992188 1371.476562 592.992188 1368.277344 C 592.992188 1365.078125 594.648438 1362.121094 597.335938 1360.519531 Z M 965.292969 1141.917969 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: -0.657,
    y1: 0.5,
    x2: 0.343,
    y2: 0.5,
    gradientTransform: "matrix(806.40625,0,0,240.546875,593.277344,1363.71875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(28.235294%,74.117647%,86.666667%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.2,
      stroke: "none"
    }
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface173",
    clipPath: "url(#clip57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,5.098039%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 1199.382812 1368.800781 C 1199.382812 1302.207031 1108.546875 1248.222656 996.492188 1248.222656 C 884.4375 1248.222656 793.601562 1302.207031 793.601562 1368.800781 C 793.601562 1435.390625 884.4375 1489.375 996.492188 1489.375 C 1108.546875 1489.375 1199.382812 1435.390625 1199.382812 1368.800781 Z M 1199.382812 1368.800781 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientUnits: "userSpaceOnUse",
    x1: -1.905,
    y1: 1.577,
    x2: -0.936,
    y2: 1.577,
    gradientTransform: "matrix(298.972656,0,0,219.847656,830.398438,604.917969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(34.117647%,38.039216%,84.313725%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "rgb(32.941176%,44.313725%,84.705882%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    style: {
      stopColor: "rgb(30.196078%,60.784314%,85.490196%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "rgb(3.529412%,27.058824%,34.509804%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "rgb(7.45098%,56.470588%,71.764706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(3.529412%,23.137255%,29.411765%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface176",
    clipPath: "url(#clip58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 391.417969 1191.765625 L 391.417969 1138.175781 C 401.847656 1143.933594 412.515625 1149.542969 423.417969 1155 L 423.417969 1208.578125 C 412.539062 1203.085938 401.871094 1197.476562 391.417969 1191.753906 Z M 288.914062 1124.824219 L 288.914062 1026.082031 C 297.578125 1032.804688 306.503906 1039.394531 315.691406 1045.859375 L 315.691406 1144.601562 C 306.503906 1138.136719 297.578125 1131.546875 288.914062 1124.824219 Z M 337.769531 1159.578125 L 337.769531 1043.105469 C 347.347656 1049.378906 357.171875 1055.503906 367.246094 1061.46875 L 367.246094 1177.941406 C 357.171875 1171.957031 347.347656 1165.835938 337.769531 1159.578125 Z M 206.695312 1048.363281 L 206.695312 919.152344 C 213.347656 926.683594 220.292969 934.105469 227.53125 941.421875 L 227.53125 1070.636719 C 220.292969 1063.316406 213.347656 1055.894531 206.695312 1048.363281 Z M 245.121094 1087.683594 L 245.121094 947.683594 C 252.808594 954.828125 260.773438 961.855469 269.015625 968.765625 L 269.015625 1108.765625 C 260.773438 1101.855469 252.808594 1094.824219 245.121094 1087.671875 Z M 147.164062 963.847656 L 147.164062 812.082031 C 151.585938 820.300781 156.332031 828.429688 161.40625 836.46875 L 161.40625 988.234375 C 156.332031 980.1875 151.585938 972.054688 147.164062 963.835938 Z M 173.929688 1007 L 173.929688 809.578125 C 179.5 817.472656 185.378906 825.273438 191.566406 832.976562 L 191.566406 1030.398438 C 185.378906 1022.699219 179.5 1014.902344 173.929688 1007.011719 Z M 126.695312 919.070312 L 126.695312 696.105469 C 129.914062 704.609375 133.46875 713.035156 137.371094 721.386719 L 137.371094 944.351562 C 133.476562 936.007812 129.921875 927.582031 126.695312 919.070312 Z M 489.152344 968.554688 C 283.0625 883.082031 140.6875 748.070312 110.867188 593.386719 L 110.867188 910.492188 C 140.6875 1065.175781 283.074219 1200.1875 489.152344 1285.660156 Z M 489.152344 968.554688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface179",
    clipPath: "url(#clip59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1093.453125 1320.8125 L 1093.453125 1249.28125 C 1128.910156 1247.289062 1163.742188 1244.105469 1197.941406 1239.730469 L 1197.941406 1311.257812 C 1163.777344 1315.613281 1128.949219 1318.796875 1093.453125 1320.8125 Z M 926.800781 1321.140625 L 926.800781 1190.777344 C 948.042969 1191.882812 969.496094 1192.550781 991.164062 1192.777344 C 1005.960938 1192.925781 1020.683594 1192.867188 1035.324219 1192.601562 L 1035.324219 1322.929688 C 1020.691406 1323.195312 1005.96875 1323.25 991.164062 1323.09375 C 969.511719 1322.875 948.058594 1322.207031 926.800781 1321.09375 Z M 766.183594 1304.035156 L 766.183594 1104.71875 C 799.769531 1110.207031 834.113281 1114.546875 869.222656 1117.730469 L 869.222656 1317.046875 C 834.175781 1313.910156 799.828125 1309.578125 766.183594 1304.046875 Z M 1252.835938 1303.1875 L 1252.835938 1092.683594 C 1286.175781 1087.105469 1318.703125 1080.4375 1350.421875 1072.683594 L 1350.421875 1283.175781 C 1318.75 1290.886719 1286.222656 1297.554688 1252.835938 1303.175781 Z M 1432.59375 1002.011719 C 1289.433594 1046.0625 1140.558594 1067.265625 991.152344 1064.882812 C 885.160156 1064.074219 779.546875 1051.710938 676.078125 1028 L 676.078125 1345.105469 C 779.546875 1368.816406 885.160156 1381.179688 991.152344 1381.988281 C 1140.558594 1384.371094 1289.433594 1363.167969 1432.59375 1319.117188 Z M 1432.59375 1002.011719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface182",
    clipPath: "url(#clip60)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1653.886719 1092.730469 L 1653.886719 1031.316406 C 1797.644531 943.941406 1891.210938 827.433594 1906.515625 697.835938 L 1906.515625 759.246094 C 1891.210938 888.835938 1797.632812 1005.304688 1653.886719 1092.730469 Z M 1908.59375 858.882812 L 1908.59375 541.777344 C 1904.023438 696.871094 1787.554688 835.328125 1605.429688 930.789062 L 1605.429688 1247.894531 C 1787.554688 1152.433594 1904.011719 1013.988281 1908.59375 858.882812 Z M 1908.59375 858.882812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface185",
    clipPath: "url(#clip61)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1906.515625 697.835938 C 1891.210938 827.445312 1797.644531 943.941406 1653.886719 1031.316406 L 1653.886719 1092.730469 C 1797.644531 1005.351562 1891.210938 888.847656 1906.515625 759.246094 Z M 1906.515625 697.835938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface188",
    clipPath: "url(#clip62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1035.304688 1192.601562 C 1020.667969 1192.867188 1005.945312 1192.925781 991.144531 1192.777344 C 969.488281 1192.550781 948.035156 1191.882812 926.777344 1190.777344 L 926.777344 1321.140625 C 948.019531 1322.246094 969.472656 1322.914062 991.144531 1323.140625 C 1005.9375 1323.289062 1020.660156 1323.234375 1035.304688 1322.976562 Z M 1035.304688 1192.601562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface191",
    clipPath: "url(#clip63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 191.566406 832.988281 C 185.378906 825.285156 179.5 817.484375 173.929688 809.589844 L 173.929688 1007.011719 C 179.5 1014.902344 185.378906 1022.699219 191.566406 1030.398438 Z M 191.566406 832.988281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface194",
    clipPath: "url(#clip64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 269.015625 968.789062 C 260.78125 961.878906 252.816406 954.851562 245.121094 947.707031 L 245.121094 1087.707031 C 252.808594 1094.851562 260.773438 1101.882812 269.015625 1108.800781 Z M 269.015625 968.789062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface197",
    clipPath: "url(#clip65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 315.691406 1045.859375 C 306.503906 1039.394531 297.578125 1032.804688 288.914062 1026.082031 L 288.914062 1124.824219 C 297.578125 1131.539062 306.503906 1138.128906 315.691406 1144.601562 Z M 315.691406 1045.859375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface200",
    clipPath: "url(#clip66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 367.257812 1061.480469 C 357.183594 1055.496094 347.359375 1049.375 337.78125 1043.117188 L 337.78125 1159.589844 C 347.359375 1165.863281 357.183594 1171.984375 367.257812 1177.953125 Z M 367.257812 1061.480469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.752941,
      stroke: "none"
    }
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2001
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface203",
    clipPath: "url(#clip67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 423.371094 1155.011719 C 412.492188 1149.523438 401.824219 1143.914062 391.371094 1138.1875 L 391.371094 1191.777344 C 401.800781 1197.535156 412.46875 1203.140625 423.371094 1208.601562 Z M 423.371094 1155.011719 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(52.54902%,52.54902%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 997.828125 1277.800781 C 991.757812 1277.960938 985.746094 1276.507812 980.378906 1273.589844 L 587.921875 1040.351562 C 583.324219 1038.097656 580.308594 1033.421875 580.070312 1028.1875 C 580.710938 1021.621094 584.703125 1015.902344 590.546875 1013.1875 L 977.738281 783.058594 C 989.929688 776.003906 1004.679688 775.425781 1017.359375 781.507812 L 1409.816406 1014.742188 C 1414.414062 1016.996094 1417.429688 1021.671875 1417.667969 1026.90625 C 1417.027344 1033.472656 1413.03125 1039.1875 1407.1875 1041.90625 L 1020 1272.035156 C 1013.207031 1275.871094 1005.574219 1277.855469 997.828125 1277.800781 Z M 983.40625 1268.175781 C 994.21875 1273.058594 1006.625 1272.484375 1016.972656 1266.625 L 1404.160156 1036.480469 C 1408.8125 1033.71875 1411.589844 1030.140625 1411.589844 1026.894531 C 1411.253906 1023.929688 1409.425781 1021.367188 1406.777344 1020.152344 L 1014.320312 786.90625 C 1003.503906 782.039062 991.105469 782.613281 980.753906 788.457031 L 593.578125 1018.601562 C 588.925781 1021.363281 586.148438 1024.941406 586.148438 1028.1875 C 586.480469 1031.152344 588.304688 1033.714844 590.949219 1034.929688 Z M 983.40625 1268.175781 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 1414.617188 856.859375 L 1414.617188 906.433594 L 997.851562 1154.128906 L 581.074219 906.421875 L 581.074219 856.847656 Z M 1414.617188 856.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.647059%,64.313725%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 997.851562 1104.554688 L 581.074219 856.847656 L 997.839844 609.152344 L 1414.617188 856.859375 Z M 997.851562 1104.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 997.851562 1098.765625 L 585.941406 853.964844 L 581.074219 856.859375 L 997.851562 1104.554688 L 1414.617188 856.859375 L 1409.75 853.964844 Z M 997.851562 1098.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 997.851562 1047.433594 L 677.292969 856.917969 L 997.839844 666.398438 L 1318.398438 856.917969 Z M 997.851562 1047.433594 "
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 197.75 1241.800781 L 342.582031 1155.917969 C 349.695312 1151.699219 358.453125 1151.699219 365.566406 1155.917969 L 510.183594 1241.871094 C 510.332031 1241.953125 510.386719 1242.105469 510.515625 1242.210938 C 511.410156 1241.515625 511.90625 1240.40625 511.839844 1239.253906 C 511.773438 1238.105469 511.152344 1237.0625 510.183594 1236.480469 L 365.566406 1150.53125 C 358.453125 1146.304688 349.695312 1146.304688 342.582031 1150.53125 L 197.75 1236.410156 C 196.78125 1236.992188 196.160156 1238.035156 196.09375 1239.183594 C 196.023438 1240.335938 196.523438 1241.445312 197.417969 1242.140625 C 197.53125 1242.035156 197.589844 1241.917969 197.75 1241.800781 Z M 197.75 1241.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 704.089844 1238.363281 L 377.632812 1431.871094 C 362.824219 1440.667969 344.582031 1440.667969 329.769531 1431.871094 L 3.769531 1238.175781 C 2.585938 1237.480469 1.609375 1236.46875 0.9375 1235.246094 C -1.121094 1239.003906 0.144531 1243.761719 3.769531 1245.917969 L 329.714844 1439.636719 C 344.523438 1448.4375 362.769531 1448.4375 377.578125 1439.636719 L 704.023438 1246.09375 C 707.644531 1243.9375 708.910156 1239.179688 706.855469 1235.421875 C 706.203125 1236.640625 705.25 1237.652344 704.089844 1238.363281 Z M 704.089844 1238.363281 "
  }), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface74",
    mask: "url(#mask23)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface77",
    mask: "url(#mask24)"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface80",
    mask: "url(#mask25)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1485.53125 1241.800781 L 1630.367188 1155.917969 C 1637.480469 1151.699219 1646.234375 1151.699219 1653.347656 1155.917969 L 1797.976562 1241.917969 C 1798.125 1242 1798.183594 1242.152344 1798.308594 1242.257812 C 1799.203125 1241.5625 1799.699219 1240.453125 1799.632812 1239.300781 C 1799.566406 1238.152344 1798.945312 1237.109375 1797.976562 1236.53125 L 1653.359375 1150.578125 C 1646.25 1146.351562 1637.488281 1146.351562 1630.378906 1150.578125 L 1485.542969 1236.457031 C 1484.574219 1237.039062 1483.953125 1238.082031 1483.886719 1239.230469 C 1483.820312 1240.382812 1484.316406 1241.492188 1485.210938 1242.1875 C 1485.335938 1242.035156 1485.394531 1241.917969 1485.53125 1241.800781 Z M 1485.53125 1241.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1991.898438 1238.363281 L 1665.484375 1431.871094 C 1650.675781 1440.667969 1632.433594 1440.667969 1617.621094 1431.871094 L 1291.679688 1238.140625 C 1290.496094 1237.445312 1289.515625 1236.433594 1288.847656 1235.210938 C 1286.785156 1238.964844 1288.050781 1243.726562 1291.679688 1245.882812 L 1617.621094 1439.601562 C 1632.429688 1448.402344 1650.675781 1448.402344 1665.484375 1439.601562 L 1991.941406 1246.058594 C 1995.566406 1243.902344 1996.828125 1239.144531 1994.777344 1235.386719 C 1994.097656 1236.632812 1993.101562 1237.660156 1991.898438 1238.363281 Z M 1991.898438 1238.363281 "
  }), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface83",
    mask: "url(#mask26)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface86",
    mask: "url(#mask27)"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface89",
    mask: "url(#mask28)"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface92",
    mask: "url(#mask29)"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface95",
    mask: "url(#mask30)"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface98",
    mask: "url(#mask31)"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface101",
    mask: "url(#mask32)"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface104",
    mask: "url(#mask33)"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface107",
    mask: "url(#mask34)"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface110",
    mask: "url(#mask35)"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface113",
    mask: "url(#mask36)"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface116",
    mask: "url(#mask37)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1759.941406 298.328125 C 1778.109375 314.496094 1795.234375 331.863281 1811.210938 350.316406 L 1811.210938 549.625 C 1795.234375 531.167969 1778.109375 513.800781 1759.941406 497.636719 Z M 1759.941406 298.328125 "
  }), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface119",
    mask: "url(#mask38)"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface122",
    mask: "url(#mask39)"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface125",
    mask: "url(#mask40)"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface128",
    mask: "url(#mask41)"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface131",
    mask: "url(#mask42)"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface134",
    mask: "url(#mask43)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 937.886719 121.257812 C 952.636719 120.601562 967.492188 120.152344 982.457031 119.917969 L 982.457031 221.929688 C 967.515625 222.15625 952.660156 222.605469 937.886719 223.269531 Z M 937.886719 121.257812 "
  }), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface137",
    mask: "url(#mask44)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 783.703125 54.589844 C 797.667969 52.484375 811.765625 50.582031 825.988281 48.871094 L 825.988281 232.398438 C 811.777344 234.109375 797.683594 236.015625 783.703125 238.117188 Z M 783.703125 54.589844 "
  }), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface140",
    mask: "url(#mask45)"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface143",
    mask: "url(#mask46)"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface146",
    mask: "url(#mask47)"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface149",
    mask: "url(#mask48)"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface152",
    mask: "url(#mask49)"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface155",
    mask: "url(#mask50)"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface158",
    mask: "url(#mask51)"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface161",
    mask: "url(#mask52)"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface164",
    mask: "url(#mask53)"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface167",
    mask: "url(#mask54)"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface170",
    mask: "url(#mask55)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear15)"
    },
    d: "M 597.324219 1367.269531 L 969.484375 1587.90625 C 986.367188 1597.933594 1007.164062 1597.933594 1024.046875 1587.90625 L 1395.632812 1367.058594 C 1396.984375 1366.265625 1398.105469 1365.113281 1398.867188 1363.71875 C 1401.21875 1368.003906 1399.777344 1373.4375 1395.632812 1375.894531 L 1024.046875 1596.742188 C 1007.164062 1606.773438 986.367188 1606.773438 969.484375 1596.742188 L 597.324219 1376.105469 C 593.1875 1373.644531 591.75 1368.210938 594.101562 1363.929688 C 594.867188 1365.320312 595.980469 1366.472656 597.324219 1367.269531 Z M 597.324219 1367.269531 "
  }), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface173",
    mask: "url(#mask56)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.627451%,3.921569%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 1073.714844 1266.566406 C 1073.714844 1266.566406 1078.652344 1271.859375 1083.761719 1278.09375 C 1091.546875 1285.359375 1100.121094 1291.675781 1109.3125 1296.917969 C 1115.359375 1300.777344 1143.050781 1322.375 1148.835938 1343.660156 C 1154.617188 1364.941406 1134.835938 1367.753906 1114.546875 1364.058594 C 1097.042969 1359.050781 1081.449219 1348.628906 1069.886719 1334.199219 C 1055.367188 1319.5625 1038.648438 1307.429688 1020.378906 1298.269531 C 995.53125 1285.035156 1010.546875 1267.234375 1010.546875 1267.234375 Z M 1073.714844 1266.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.627451%,3.921569%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 889.28125 1329.765625 C 886.523438 1336.761719 884.753906 1344.125 884.023438 1351.636719 C 882.878906 1363.941406 881.1875 1390.613281 880.59375 1398.421875 C 879.230469 1414.546875 883.667969 1430.625 893.0625 1443.601562 C 906.410156 1461.882812 913.292969 1469.105469 931.027344 1461.917969 C 948.765625 1454.730469 948.367188 1424.082031 945.222656 1408.328125 C 942.199219 1390.230469 940.292969 1371.957031 939.507812 1353.613281 C 939.738281 1351.53125 939.386719 1349.421875 938.492188 1347.542969 Z M 889.28125 1329.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 1134.902344 905.09375 C 1134.902344 905.09375 1131.164062 1045.589844 1099.359375 1120.175781 C 1084.492188 1166.695312 1075.816406 1215.070312 1073.566406 1263.988281 C 1076.515625 1272.035156 1075.703125 1281.03125 1071.359375 1288.375 C 1063.898438 1299.316406 1017.199219 1309.316406 1009.484375 1273.398438 C 1002.5 1229.832031 1003.769531 1185.285156 1013.222656 1142.210938 C 1021.703125 1114.175781 1010.207031 1036.90625 1010.207031 1036.90625 C 1010.207031 1036.90625 997.441406 1045.292969 980.707031 1100.8125 C 971.15625 1132.265625 959.53125 1163.011719 945.910156 1192.835938 C 940.195312 1208.128906 934.855469 1302.246094 938.515625 1348.128906 C 938.515625 1348.128906 900.695312 1353.648438 889.761719 1335.046875 C 878.824219 1316.445312 875.164062 1220.175781 877.941406 1189.480469 C 880.71875 1158.789062 893.175781 1060.46875 891.460938 1030.046875 C 889.75 999.625 883.589844 974.917969 890.320312 944.53125 C 897.050781 914.140625 1096.617188 846.625 1096.617188 846.625 Z M 1134.902344 905.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 891.460938 1030.09375 C 889.75 999.671875 883.589844 974.964844 890.320312 944.578125 C 892.855469 933.152344 922.652344 916.480469 958.890625 900.128906 C 1019.953125 894.386719 1097.40625 887.730469 1102.742188 888.566406 C 1112.273438 891.191406 1121.601562 894.535156 1130.652344 898.578125 L 1134.914062 905.082031 C 1134.914062 905.082031 1134.6875 913.625 1133.863281 927.578125 C 1120.070312 929.898438 1105.996094 929.851562 1092.21875 927.433594 C 1079 952.582031 1059.15625 973.378906 1034.972656 987.433594 C 1005.371094 1002.566406 918.765625 997.375 913.828125 1003.117188 C 908.890625 1008.859375 907.898438 1085.789062 908.445312 1095.566406 C 908.996094 1105.339844 900.285156 1166.917969 892.230469 1221.363281 C 888.054688 1261.636719 889.597656 1302.316406 896.800781 1342.128906 C 893.980469 1340.363281 891.597656 1337.945312 889.839844 1335.070312 C 878.902344 1316.457031 875.246094 1220.199219 878.023438 1189.507812 C 880.800781 1158.8125 893.175781 1060.519531 891.460938 1030.09375 Z M 891.460938 1030.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 1068.113281 445.542969 C 1068.113281 445.542969 1112.386719 455.941406 1127.28125 459.542969 C 1129.738281 460.132812 1131.753906 461.933594 1132.675781 464.351562 C 1143.273438 495.433594 1145.675781 528.851562 1139.632812 561.199219 C 1133.664062 595.683594 1131.367188 630.734375 1132.777344 665.730469 L 1153.246094 775.433594 C 1153.246094 775.433594 1178.996094 879.917969 1176.765625 882.777344 C 1174.539062 885.636719 1117.484375 930.328125 1099.65625 924.035156 C 1081.828125 917.742188 1087.679688 907.351562 1087.679688 907.351562 C 1087.679688 907.351562 1073.234375 983.070312 1009.292969 982.351562 C 945.347656 981.636719 893.121094 981.835938 882.261719 955.234375 C 871.40625 928.636719 885.234375 816.777344 896.503906 772.507812 C 907.769531 728.234375 934.570312 639.953125 934.570312 639.953125 L 840.925781 533.246094 L 920.925781 470.328125 C 920.925781 470.328125 940.046875 433.753906 947.898438 429.152344 C 955.75 424.554688 959.863281 428.445312 959.863281 428.445312 Z M 1068.113281 445.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 1098.59375 899.929688 C 1098.59375 903.730469 1100.695312 909.339844 1112.183594 913.445312 C 1124.59375 917.824219 1155.015625 898.800781 1174.972656 884.457031 C 1165.003906 892.976562 1116 929.8125 1099.703125 924.046875 C 1096.847656 923.105469 1094.148438 921.71875 1091.703125 919.929688 C 1094.507812 913.460938 1096.8125 906.773438 1098.59375 899.929688 Z M 1098.59375 899.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 882.777344 946.363281 C 894.207031 974.445312 949.359375 974.222656 1016.835938 974.988281 C 1031.726562 975.394531 1046.378906 971.046875 1058.777344 962.542969 C 1045.574219 975.75 1027.742188 982.902344 1009.335938 982.363281 C 945.40625 981.636719 893.164062 981.847656 882.308594 955.246094 C 878.339844 939.46875 877.097656 923.09375 878.640625 906.871094 C 877.808594 920.183594 879.210938 933.542969 882.777344 946.363281 Z M 882.777344 946.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.117647%,96.470588%,100%)",
      fillOpacity: 1
    },
    d: "M 949.726562 428.1875 C 949.726562 428.1875 933.371094 448.554688 956.902344 476.035156 C 979.554688 504.65625 999.816406 535.199219 1017.472656 567.328125 C 1030.730469 590.988281 1042.996094 603.613281 1049.929688 623.941406 C 1049.929688 623.941406 1050.902344 599.789062 1051.839844 562.480469 C 1052.71875 527.28125 1053.175781 490.71875 1051.644531 481.492188 C 1048.546875 462.519531 967.792969 418.929688 949.726562 428.1875 Z M 949.726562 428.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1010.867188 489.433594 C 1010.867188 489.433594 1019.246094 494.800781 1022.136719 494.351562 C 1025.027344 493.90625 1034.296875 484.636719 1034.296875 484.636719 C 1034.296875 484.636719 1057.507812 484.199219 1060.046875 473.976562 C 1061.71875 465.222656 1063.90625 456.578125 1066.59375 448.09375 C 1072.457031 434.980469 1076.636719 421.140625 1079.027344 406.917969 C 1078.230469 393.882812 1079.597656 380.804688 1083.074219 368.246094 C 1087.429688 358.445312 1093.292969 260.386719 1001.304688 263.140625 C 909.3125 265.894531 937.898438 364.234375 937.898438 364.234375 C 937.898438 364.234375 931.175781 367.1875 935.246094 379.835938 C 939.3125 392.480469 940.230469 393.800781 942.296875 400.082031 C 943.558594 406.089844 946.703125 411.507812 951.246094 415.492188 L 952.765625 427.152344 C 950.5 439.355469 953.039062 451.984375 959.828125 462.257812 C 971.269531 479.542969 1010.867188 489.433594 1010.867188 489.433594 Z M 1010.867188 489.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 1129.792969 460.671875 C 1129.792969 460.671875 1139.601562 462.175781 1171.429688 544.589844 C 1189.175781 590.578125 1216.59375 638.199219 1222.398438 672.375 C 1228.207031 706.554688 1224.972656 743.082031 1218.410156 745.660156 C 1212.089844 748.128906 1097.75 792.175781 1061.964844 806.082031 C 1061.027344 806.445312 1059.980469 806.355469 1059.113281 805.84375 C 1058.242188 805.328125 1057.640625 804.441406 1057.472656 803.421875 L 1047.613281 746.578125 L 1118.570312 718.339844 C 1125.957031 709.074219 1134.839844 701.183594 1144.824219 695.011719 C 1144.824219 695.011719 1130.59375 668.023438 1131.507812 660.660156 C 1132.421875 653.292969 1130.238281 577.058594 1138.546875 546.035156 C 1146.855469 515.011719 1129.792969 460.671875 1129.792969 460.671875 Z M 1129.792969 460.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1088.238281 678.46875 C 1092.171875 675.691406 1096.238281 673.113281 1100.421875 670.753906 C 1102.847656 669.789062 1115.910156 665.199219 1118.398438 664.046875 C 1122.816406 663.5 1127.28125 663.566406 1131.679688 664.246094 C 1133.054688 664.382812 1134.273438 665.214844 1134.925781 666.46875 C 1140.234375 675.320312 1143.796875 685.15625 1145.417969 695.421875 C 1145.417969 695.421875 1121.792969 710.789062 1119.132812 717.648438 L 1115.359375 718.480469 C 1115.359375 718.480469 1099.554688 683.519531 1088.238281 678.46875 Z M 1088.238281 678.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 896.546875 772.507812 C 899.269531 761.847656 902.878906 748.636719 906.835938 734.730469 L 1050.539062 798.140625 C 1020.351562 832.34375 976.988281 851.003906 932.136719 849.09375 C 915.582031 848.132812 899.527344 842.910156 885.441406 833.90625 C 888.089844 813.253906 891.796875 792.757812 896.546875 772.507812 Z M 896.546875 772.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.117647%,7.058824%,41.568627%)",
      fillOpacity: 1
    },
    d: "M 840.984375 533.234375 C 840.984375 533.234375 878.878906 538.613281 909.554688 588.53125 C 929.957031 622.945312 947.65625 658.984375 962.480469 696.304688 L 963.53125 702.800781 C 964.828125 710.835938 969.671875 717.800781 976.644531 721.65625 C 983.613281 725.511719 991.925781 725.824219 999.152344 722.507812 C 1031.484375 707.648438 1079.371094 685.175781 1088.296875 678.433594 C 1107.175781 690.839844 1120.339844 710.621094 1124.753906 733.222656 C 1130.984375 763.929688 1129.394531 764.011719 1129.394531 764.011719 C 1129.394531 764.011719 1001.78125 825.316406 952.503906 824.730469 C 903.222656 824.140625 840.695312 657.328125 833.816406 622.847656 C 826.9375 588.363281 819.292969 542.988281 840.984375 533.234375 Z M 840.984375 533.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 840.984375 533.234375 C 840.984375 533.234375 878.878906 538.613281 909.554688 588.53125 C 929.957031 622.945312 947.65625 658.984375 962.480469 696.304688 L 963.53125 702.800781 C 964.828125 710.835938 969.671875 717.800781 976.644531 721.65625 C 983.613281 725.511719 991.925781 725.824219 999.152344 722.507812 C 1031.484375 707.648438 1079.371094 685.175781 1088.296875 678.433594 C 1107.175781 690.839844 1120.339844 710.621094 1124.753906 733.222656 C 1130.984375 763.929688 1129.394531 764.011719 1129.394531 764.011719 C 1129.394531 764.011719 1001.78125 825.316406 952.503906 824.730469 C 903.222656 824.140625 840.695312 657.328125 833.816406 622.847656 C 826.9375 588.363281 819.292969 542.988281 840.984375 533.234375 Z M 840.984375 533.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.058824%,23.529412%,61.960784%)",
      fillOpacity: 1
    },
    d: "M 980.777344 730.316406 C 980.777344 730.316406 964.675781 745.8125 957.667969 737.375 C 950.664062 728.941406 952.730469 727.964844 952.730469 727.964844 C 952.730469 727.964844 938.25 727.835938 936.492188 718.480469 C 934.730469 709.128906 927.601562 714.082031 927.1875 703.671875 C 926.777344 693.257812 938.914062 695.433594 938.914062 695.433594 Z M 980.777344 730.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,64.313725%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 1000.238281 722.023438 C 1000.238281 722.023438 995.816406 717.789062 990.101562 712.8125 C 983.792969 704.234375 978.265625 695.074219 973.601562 685.445312 C 964.957031 677.433594 954.671875 671.527344 943.507812 668.164062 C 934.230469 667.90625 941.121094 678.589844 943.257812 680.105469 C 945.394531 681.625 954.457031 686.257812 954.457031 686.257812 C 954.457031 686.257812 963.78125 694.316406 964.847656 695.507812 C 965.910156 696.695312 938.925781 693.589844 934.640625 696.304688 C 932.867188 697.691406 931.804688 699.832031 931.75 702.121094 C 931.699219 704.414062 932.667969 706.601562 934.378906 708.070312 C 935.957031 709.179688 937.804688 709.820312 939.714844 709.929688 C 937.972656 714.746094 940.195312 720.121094 944.777344 722.164062 C 952.878906 726.035156 954.742188 723.882812 954.742188 723.882812 C 954.742188 723.882812 955.441406 738.316406 968.8125 735.457031 Z M 1000.238281 722.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.568627%,10.196078%,12.941176%)",
      fillOpacity: 1
    },
    d: "M 1085.152344 318.070312 C 1085.152344 318.070312 1097.164062 357.410156 1065.566406 346.222656 C 1033.964844 335.035156 1005.359375 316.292969 995.441406 323.421875 C 987.886719 328.859375 988.230469 345.507812 988.824219 353.140625 C 989.027344 355.734375 988.359375 358.324219 986.925781 360.46875 L 977.554688 374.492188 C 976.496094 376.074219 975.871094 377.921875 975.738281 379.835938 L 975.074219 389.589844 C 974.90625 392.042969 972.992188 393.988281 970.605469 394.128906 L 968.445312 394.257812 C 966.035156 394.410156 963.898438 392.671875 963.484375 390.222656 L 961.015625 375.917969 C 961.015625 375.917969 953.578125 356.648438 937.851562 364.222656 C 930.320312 350.347656 927.832031 334.167969 930.835938 318.578125 C 934.332031 287.480469 947.863281 255.140625 1007.144531 249.976562 C 1066.421875 244.8125 1085.152344 318.070312 1085.152344 318.070312 Z M 1085.152344 318.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.862745%,80%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 994.546875 524.070312 L 1003.417969 517.011719 C 1008.085938 521.039062 1011.964844 525.945312 1014.847656 531.46875 C 1016.496094 541.765625 1016.496094 552.269531 1014.847656 562.566406 L 1017.554688 567.351562 L 1020.878906 561.09375 L 1023.691406 533.128906 C 1023.691406 533.128906 1020.675781 512.457031 1020.378906 511.953125 C 1020.078125 511.445312 1003.234375 513.789062 1003.234375 513.789062 C 999.726562 516.613281 996.777344 520.101562 994.546875 524.070312 Z M 994.546875 524.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.862745%,80%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 1037.210938 496.199219 C 1042.054688 496.476562 1046.757812 497.953125 1050.925781 500.507812 C 1050.925781 500.507812 1040.984375 501.011719 1039.40625 501.1875 C 1037.828125 501.363281 1037.210938 496.199219 1037.210938 496.199219 Z M 1037.210938 496.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509804%,34.117647%,34.117647%)",
      fillOpacity: 1
    },
    d: "M 1019.152344 498.433594 L 1003.246094 513.730469 C 1011.339844 517.710938 1017.707031 524.652344 1021.109375 533.199219 C 1021.109375 533.199219 1038.421875 536.53125 1040 530.070312 C 1041.578125 523.613281 1040 507.363281 1042.023438 500.152344 C 1044.046875 492.941406 1019.152344 498.433594 1019.152344 498.433594 Z M 1019.152344 498.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509804%,34.117647%,34.117647%)",
      fillOpacity: 1
    },
    d: "M 1039.359375 529.707031 C 1040.738281 536.234375 1042.8125 542.585938 1045.542969 548.648438 C 1048.777344 554.175781 1052.078125 560.410156 1052.078125 560.410156 L 1051.691406 638.976562 C 1051.691406 638.976562 1023.613281 579.410156 1017.53125 567.351562 C 1017.675781 555.890625 1018.875 544.464844 1021.109375 533.234375 C 1023.75 527.777344 1039.359375 529.707031 1039.359375 529.707031 Z M 1039.359375 529.707031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,61.568627%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 963.964844 413.601562 C 976.023438 446.832031 1001.78125 472.851562 1034.285156 484.636719 C 1034.285156 484.636719 1025.015625 493.90625 1022.125 494.351562 C 1019.234375 494.800781 1010.855469 489.433594 1010.855469 489.433594 C 1010.855469 489.433594 971.246094 479.542969 959.804688 462.222656 C 953.019531 451.949219 950.476562 439.320312 952.742188 427.117188 L 951.222656 415.457031 C 955.480469 417.292969 960.371094 416.582031 963.964844 413.601562 Z M 963.964844 413.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 921.78125 477.71875 C 921.78125 477.71875 929.0625 503.601562 930 504.542969 C 936.113281 504.691406 942.230469 504.328125 948.285156 503.445312 L 939.851562 519.917969 C 939.851562 519.917969 1027.1875 616.328125 1045.292969 668.152344 C 1011.296875 616.847656 973.140625 568.597656 931.234375 523.917969 L 941.519531 507.882812 L 923.667969 511.46875 Z M 921.78125 477.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,14.901961%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 1065.234375 454.894531 L 1069.804688 460.339844 L 1064.367188 465.578125 L 1080.515625 480.601562 C 1080.515625 480.601562 1085.453125 586.058594 1065.726562 655.894531 C 1065.726562 655.894531 1092.503906 591.8125 1086.421875 477.695312 L 1068.949219 465.492188 L 1074.664062 459.707031 Z M 1065.234375 454.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,19.215686%,23.921569%)",
      fillOpacity: 1
    },
    d: "M 1010.195312 1036.90625 C 1009.984375 1037.058594 1009.78125 1037.222656 1009.589844 1037.398438 L 1032.21875 1012.613281 C 1021.769531 1027.765625 1033.804688 1097.1875 1035.050781 1113.082031 C 1036.296875 1128.976562 1022.972656 1161.800781 1017.976562 1200.257812 C 1015.789062 1231.492188 1017.558594 1262.882812 1023.234375 1293.648438 C 1016.019531 1289.269531 1011.015625 1281.878906 1009.519531 1273.398438 C 1002.535156 1229.832031 1003.804688 1185.285156 1013.257812 1142.210938 C 1021.703125 1114.175781 1010.195312 1036.90625 1010.195312 1036.90625 Z M 1010.195312 1036.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear16)"
    },
    d: "M 952.445312 824.765625 C 903.164062 824.152344 840.640625 657.363281 833.761719 622.882812 C 832.617188 617.128906 831.472656 611.117188 830.398438 604.917969 C 830.570312 605.421875 843.347656 641.386719 855.65625 673.363281 C 868.058594 705.519531 933.921875 802.976562 967.566406 809.316406 C 997.910156 815.046875 1107.085938 762.578125 1128.230469 752.222656 C 1130.136719 763.988281 1129.371094 763.988281 1129.371094 763.988281 C 1129.371094 763.988281 1001.726562 825.351562 952.445312 824.765625 Z M 952.445312 824.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313725%,15.686275%,19.215686%)",
      fillOpacity: 1
    },
    d: "M 968.445312 394.257812 C 966.035156 394.410156 963.898438 392.671875 963.484375 390.222656 L 961.050781 375.894531 C 961.050781 375.894531 953.613281 356.625 937.886719 364.199219 C 930.738281 351.078125 928.183594 335.828125 930.652344 321 C 948.125 348.058594 986.925781 360.480469 986.925781 360.480469 L 977.554688 374.507812 C 976.496094 376.085938 975.871094 377.933594 975.738281 379.847656 L 975.074219 389.601562 C 974.90625 392.054688 972.992188 394 970.605469 394.140625 Z M 968.445312 394.257812 "
  }), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface176",
    mask: "url(#mask57)"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface179",
    mask: "url(#mask58)"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface182",
    mask: "url(#mask59)"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface185",
    mask: "url(#mask60)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 869.164062 1117.730469 C 834.117188 1114.59375 799.769531 1110.253906 766.125 1104.71875 L 766.125 1304.035156 C 799.710938 1309.527344 834.058594 1313.859375 869.164062 1317.035156 Z M 869.164062 1117.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1197.929688 1239.71875 C 1163.769531 1244.070312 1128.9375 1247.253906 1093.441406 1249.269531 L 1093.441406 1320.800781 C 1128.898438 1318.808594 1163.730469 1315.625 1197.929688 1311.246094 Z M 1197.929688 1239.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 1350.410156 1072.71875 C 1318.738281 1080.425781 1286.210938 1087.09375 1252.824219 1092.71875 L 1252.824219 1303.175781 C 1286.164062 1297.601562 1318.691406 1290.933594 1350.410156 1283.175781 Z M 1350.410156 1072.71875 "
  }), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface188",
    mask: "url(#mask61)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 137.371094 721.386719 C 133.476562 713.035156 129.921875 704.609375 126.695312 696.105469 L 126.695312 919.070312 C 129.914062 927.574219 133.46875 936 137.371094 944.351562 Z M 137.371094 721.386719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 161.40625 836.480469 C 156.332031 828.441406 151.585938 820.3125 147.164062 812.09375 L 147.164062 963.859375 C 151.585938 972.078125 156.332031 980.210938 161.40625 988.257812 Z M 161.40625 836.480469 "
  }), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface191",
    mask: "url(#mask62)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.45098%,56.470588%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 227.53125 941.421875 C 220.292969 934.105469 213.347656 926.683594 206.695312 919.152344 L 206.695312 1048.363281 C 213.347656 1055.894531 220.292969 1063.316406 227.53125 1070.636719 Z M 227.53125 941.421875 "
  }), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface194",
    mask: "url(#mask63)"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface197",
    mask: "url(#mask64)"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface200",
    mask: "url(#mask65)"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface203",
    mask: "url(#mask66)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminc);
export default __webpack_public_path__ + "static/media/adminc.b95abbacf558fa29a50abed008a48bff.svg";
export { ForwardRef as ReactComponent };